import { lazy, Suspense } from 'react';

import { Route, Routes } from 'react-router-dom';

import RouteAuth from '../../core/security/routeAuth';
import { Role } from '../Security/models/Authorization';
const FormVersion = lazy(() => import('./FormVersion').then((m) => ({ default: m.FormVersion })));

const AdminFormStatement = lazy(() =>
  import('./FormAdministration').then((m) => ({ default: m.AdminFormStatement }))
);
export const TaxStatementRouting = () => {
  return (
    <Routes>
      <Route
        path="form/administration/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <Suspense fallback={<></>}>
              <AdminFormStatement />
            </Suspense>
          </RouteAuth>
        }
      />
      <Route
        path="form/version/:formId/*"
        element={
          <RouteAuth access={[Role.FormsAdmin]}>
            <Suspense fallback={<></>}>
              <FormVersion />
            </Suspense>
          </RouteAuth>
        }
      />
    </Routes>
  );
};
